import PerfectScrollbar from 'perfect-scrollbar';

export default () => {

  const r = {};
  const init = () => {
    const isPc = window.matchMedia('(min-width: 769px').matches;
    r.root = document.querySelector('.js-scroll-area');
    if (!r.root || isPc) {
      return;
    }
    buildScrollBar();
  }

  const buildScrollBar = () => {
    const scrollArea = r.root.querySelector('.le-rule__details-inner');
    new PerfectScrollbar(scrollArea, {
      scrollXMarginOffset: 0,
      swipePropagation: false
    });

    const rail = r.root.querySelector('.le-rule__details-rail');
    const thumb = r.root.querySelector('.le-rule__details-thumb');
    scrollArea.addEventListener('scroll', (evt) => {
      const rate = evt.target.scrollLeft / (evt.target.scrollWidth - scrollArea.clientWidth)
      const setTranslateX = (rail.clientWidth - thumb.clientWidth) * rate
      thumb.style.transform = `translateX(${setTranslateX}px)`
    })

  }

  init();

  return {}
}
